export default __webpack_public_path__ + "ff56b14cee543e58d99d3e6c2b5da60d.png";